exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-wrap[data-v-6a6480c0] {\n  width: 100%;\n}\n.script-template[data-v-6a6480c0] {\n  height: 250px;\n  overflow-y: scroll;\n}\n.instructions[data-v-6a6480c0] {\n  height: 502px;\n  overflow-y: scroll;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a6480c0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/companies/CompaniesWebQuoteCustom.vue
// module id = QoxF
// module chunks = 0